<script>
import abstractField from '../abstractField';
import { h, resolveComponent } from 'vue';

export default {
  name: 'field-date-range',
  mixins: [abstractField],
  computed: {},
  methods: {
    onInput(val) {
      this.value = val;
    }
  },
  render() {
    const legoDatePicker = resolveComponent('lego-date-picker');
    return h(legoDatePicker, {
      modelValue: this.value,
      'onUpdate:modelValue': this.onInput,
      style: {
        maxWidth: this.schema.maxWidth && `${this.schema.maxWidth}px`
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.lego-date-picker + .lego-date-picker {
  margin-left: 21px !important;
  position: relative;

  &:before {
    content: '~';
    position: absolute;
    left: -15px;
  }
}
</style>
